import React from "react";
import { useDropshippingText } from "../i18n";
import { changeLinkFulfillment } from "../services/wholesaleService";
import { listSellerProviderLinks } from "../services/providerProductService";

// "Change Fulfillment Mode": the server only accepts modes backed by REAL sources (Provider allows dropshipping / the Seller owns
// purchased units) and answers with the allowed list. Used on the product page and on the linked-products page; `linkId` is
// optional (looked up from the Seller's links when the caller only knows the Provider product).
export default function FulfillmentChanger({ providerProductId, linkId, token, onChanged, current }) {
  const ct = useDropshippingText(null, "dropshippingCommercial");
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const change = async (mode) => {
    if (!mode) return;
    setBusy(true); setMsg("");
    let id = linkId;
    if (!id) {
      const links = await listSellerProviderLinks(token);
      id = (links?.items || []).find((l) => String(l.providerProductId?._id || l.providerProductId) === String(providerProductId))?._id;
    }
    const r = id ? await changeLinkFulfillment(token, id, mode) : { error: ct("noLinkFound") };
    setBusy(false);
    if (r?.error) setMsg(r.error); else onChanged?.(id, mode);
  };
  return (
    <label className="pc-field"><span>{ct("changeFulfillment")}</span>
      <select disabled={busy} value="" onChange={(e) => change(e.target.value)}>
        <option value="">{current || "—"}</option>
        <option value="PROVIDER_DROPSHIPPING">{ct("modeDs")}</option>
        <option value="PROVIDER_STOCK_SELLER_OWNED">{ct("modeStore")}</option>
        <option value="SELLER_STOCK">{ct("modeShip")}</option>
      </select>
      {msg && <small role="alert">{msg}</small>}
    </label>
  );
}
